import Button from "@pathwright/ui/src/components/button/Button"
import Pathicon from "@pathwright/ui/src/components/pathicon/Pathicon"
import ConnectStores from "lib/core/store/components/ConnectStores"
import PathListPaste from "../PathListPaste"
import "./PathStepCreate.css"
import PathStepFormContainer from "./PathStepFormContainer"

const PathStepCreate = function ({
  order,
  parent,
  step_prompt,
  isSelected,
  selectNewStep,
  unSelectPathItem
}) {
  if (isSelected) {
    return <PathStepFormContainer actionLabel="Add Step" />
  } else {
    return (
      <div className="PathStep__Create">
        <Button
          className="PathStep__Add"
          styleType="secondary"
          onClick={selectNewStep}
          rounded={false}
          inverted={true}
          stretch={true}
        >
          <Pathicon icon="plus-circle" /> Add step to watch, read, listen,...
        </Button>
        <PathListPaste size={60} type="A" order={order} parent={parent} />
      </div>
    )
  }
}

const mapStateToProps = function (state, ownProps) {
  const { getGroupById } = state.pathStore.request
  const { selection } = state.pathAdminStore.state
  const { selectNewPathItem, unSelectPathItem } = state.pathAdminStore.action

  const step_prompt = __guard__(
    getGroupById(ownProps.parent),
    (x) => x.items.length
  )
    ? "Add another step"
    : "Add step"
  const isSelected =
    selection &&
    selection.item_type === "A" &&
    selection.parent === ownProps.parent &&
    !selection.id
  const selectNewStep = function () {
    const data = {
      item_type: "A",
      parent: ownProps.parent,
      order: ownProps.order
    }
    return selectNewPathItem(data)
  }

  const props = _.assign(
    {},
    {
      // props
      step_prompt,
      // state
      isSelected,
      // actions
      selectNewStep,
      unSelectPathItem
    },
    ownProps
  )
  return props
}

const stores = [
  { store: "path", watch: false },
  { store: "pathAdmin", watch: ["selection"] }
]

PathStepCreate.displayName = "PathStepCreate"
export default ConnectStores(PathStepCreate, stores, {}, mapStateToProps)

function __guard__(value, transform) {
  return typeof value !== "undefined" && value !== null
    ? transform(value)
    : undefined
}
